import React, { useEffect } from 'react';
import { Link, useParams, } from 'react-router-dom';

import PrivateHeader from 'containers/parts/PrivateHeader';
import SiteMain from 'containers/parts/SiteMain';
import StudentBar from '../parts/CommonStudentBar'
import StudentNav from '../parts/InstructorStudentNav';
import CircleChart from '../parts/CircleChart'

import { mappedProps } from 'containers/instructor/StudentStudyResult';

const StudentStudyResult: React.FC<mappedProps> = (props: mappedProps) => {
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      props.fetchData(Number(id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const student = props.getStudent(Number(id))
  const curriculums = props.curriculums

  return (
    <React.Fragment>
      <PrivateHeader />
      <SiteMain>
        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          <li className="breadcrumbs__item">
            受講者情報
          </li>
        </ol>

        {
          student && 
          <div className="site-main__main-contents">
            <StudentBar student={student} />
            <StudentNav student={student} type="study_result" />

            <div className="study-breadcrumbs">
              <div className="study-breadcrumbs__item">
                教科
              </div>
            </div>

            <div className="page-subtitle">
              学習結果（コンプリート率）
            </div>

            <ul className="study-result-list study-result-list--teacher">
              {
                curriculums && curriculums.map(curriculum => (
                  <li key={curriculum.code} className="study-result-list__item">
                    <div className="study-result">
                      <div className="study-result__chart">
                        <CircleChart label={curriculum.name} rate={0} />
                      </div>
                      <div className="study-result__button">
                        <Link to={`/students/${student.id}/study_result/${curriculum.code}`} className="button button--short">
                          { curriculum.name }科目一覧
                        </Link>
                      </div>
                    </div>
                  </li>
                ))
              }
            </ul>
            <div className="back-home">
              <Link to='/' className="back-home__link">マイページへ戻る</Link>
            </div>
          </div>
        }

        <ol className="breadcrumbs">
          <li className="breadcrumbs__item">
            <Link to='/' className="breadcrumbs__link">マイページ</Link>
          </li>
          <li className="breadcrumbs__item">
            受講者情報
          </li>
        </ol>
      </SiteMain>
    </React.Fragment>
  );
}

export default StudentStudyResult
